import { render, staticRenderFns } from "./MultiLiveEvents.vue?vue&type=template&id=5c8f7d0b"
import script from "./MultiLiveEvents.vue?vue&type=script&lang=js"
export * from "./MultiLiveEvents.vue?vue&type=script&lang=js"
import style0 from "./MultiLiveEvents.vue?vue&type=style&index=0&id=5c8f7d0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports